import { Component } from '@angular/core';
@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {

    isCollapsed = false; // State to control sidebar collapse
    isMobile = false;

    constructor(
    ) {}

    ngOnInit(): void {  
    }

}
